<template>
  <main>
    <!-- Desktop layout -->
    <div v-if="isDesktop" class="expert-page-desktop">
      <GFMP v-if="loading.banners" :styles="{ minHeight: '380px', width: '100%' }" />
      <carousel
        v-else-if="banners.length"
        :per-page="1"
        :autoplay="true"
        :autoplay-speed="6000"
        pagination-color="#E5E5E5"
        pagination-active-color="#F384A7"
        :navigation-enabled="true"
        :navigation-click-target-size="0"
        loop
        navigation-next-label
        navigation-prev-label
        class="expert-page-banner"
      >
        <slide v-for="(bannerItem, key) in banners.slice(0, 3)" :key="`expert-page-banner-${key}`">
          <a :href="bannerItem.url" target="_blank" rel="noopener">
            <img :src="bannerItem.image" :alt="bannerItem.name" class="expert-main-banner" />
          </a>
        </slide>
      </carousel>
      <article v-if="experts.length" class="meet-our-experts">
        <header>
          <h1>Meet Our Experts</h1>
          <small v-if="!loading.experts && experts.length" class="see-all"><a href="/expert/users">See all</a></small>
        </header>
        <section>
          <ul>
            <template v-if="loading.experts">
              <li v-for="i in 6" :key="i">
                <GFMP :styles="{ minHeight: '293px', width: '165px' }" />
              </li>
            </template>
            <template v-else>
              <li
                v-for="(expertUser, index) in experts"
                :key="index"
                class="the-experts"
                :class="{ 'default-image': !expertUser.meet_your_expert_banner }"
              >
                <a :href="usernameUrl(expertUser.user_name)" target="_blank" rel="noopener">
                  <img
                    :src="expertUser.meet_your_expert_banner || '/assets/img/default-avatar.png'"
                    :alt="expertUser.user_name"
                    height="293"
                    width="165"
                    fetchpriority="high"
                    loading="eager"
                  />
                </a>
                <!-- <div class="expert-role-wrapper">
                  <h5>{{ (expertUser.name || `${expertUser.first_name} ${expertUser.last_name}`) | startCase }}</h5>
                  <small v-if="expertUser.expert_role" class="expert-role">{{
                    expertUser.expert_role | startCase
                  }}</small>
                </div> -->
              </li>
            </template>
          </ul>
        </section>
      </article>
      <article ref="recentlyReviewed" class="recently-reviewed-by-experts">
        <header>
          <h1>Recently Reviewed By The Experts</h1>
        </header>
        <section>
          <div v-if="loading.reviews" style="display: flex; flex-direction: column; gap: 24px">
            <GFMP v-for="i in 3" :key="i" :styles="{ height: '180px', width: '1092px' }" />
          </div>
          <template v-else>
            <CardReviewDetailV2
              v-for="(review, key) in reviews"
              :key="review._id"
              :review-data="review"
              :left-column="4"
              :right-column="8"
              :show-bookmark="true"
              is-expert-review
              on="expert-page"
              :index="key"
              @set-bookmark="onSetBookmark"
              @set-like="onSetLike"
            />
            <!-- <Pagination
              v-if="options.total > options.limit"
              key="Pagination"
              :limit="options.limit"
              :skip="options.skip"
              :total-item="options.total"
              :active-pagination="activePagination"
              @skipTo="onSkip"
            /> -->
            <template v-if="reviews.length < options.total">
              <GLoaderSpin v-if="loading.moreReviews" />
              <button v-else class="btn btn-loadmore" @click="onLoadMore">Load more reviews</button>
            </template>
          </template>
        </section>
      </article>
    </div>
    <!-- Mobile layout -->
    <div v-else class="expert-page-mobile">
      <section class="expert-page-banner">
        <GFMP
          v-if="loading.banners"
          :styles="{
            minHeight: '184.5px',
            width: 'calc(100% - 32px)',
            minWidth: '328px',
            margin: '0 16px',
            borderRadius: '8px',
          }"
        />
        <ul v-else-if="banners.length">
          <li
            v-for="(bannerItem, key) in banners"
            :key="key"
            :style="{ '--background-mobile': `url(${mainImage(bannerItem.image)})` }"
          ></li>
        </ul>
      </section>
      <hr class="separator" />
      <article v-if="experts.length" class="meet-our-experts">
        <header>
          <h1>Meet Our Experts</h1>
          <small v-if="!loading.experts && experts.length" class="see-all"><a href="/expert/users">See all</a></small>
        </header>
        <section>
          <GFMP v-if="loading.experts" :styles="{ minHeight: '380px', borderRadius: '8px' }" />
          <carousel
            v-else-if="experts.length"
            :per-page="3"
            pagination-color="#E5E5E5"
            pagination-active-color="#F384A7"
            class="meet-our-experts-carousel"
          >
            <slide v-for="(expertUser, key) in experts" :key="`meet-our-experts-${key}`" class="slides">
              <a :href="usernameUrl(expertUser.user_name)" target="_blank" rel="noopener">
                <img
                  :src="expertUser.meet_your_expert_banner || '/assets/img/default-avatar.png'"
                  :alt="expertUser.user_name"
                  fetchpriority="high"
                  height="202"
                  loading="eager"
                  style="object-fit: cover; width: calc(100% - 8px); border-radius: 4px"
                />
              </a>
              <!-- <div class="expert-role-wrapper">
                <h5>{{ (expertUser.name || `${expertUser.first_name} ${expertUser.last_name}`) | startCase }}</h5>
                <small v-if="expertUser.expert_role" class="expert-role">{{
                  expertUser.expert_role | startCase
                }}</small>
              </div> -->
            </slide>
          </carousel>
        </section>
      </article>
      <hr class="separator" />
      <article class="recently-reviewed-by-experts">
        <header>
          <h1>Recently Reviewed by the Experts</h1>
        </header>
        <section>
          <div v-if="loading.reviews" style="display: flex; flex-direction: column; gap: 24px">
            <GFMP v-for="i in 3" :key="i" :styles="{ height: '180px', width: 'auto' }" />
          </div>
          <template v-else>
            <CardReviewDetail
              v-for="review in reviews"
              :key="review._id"
              :review-data="review"
              :left-column="4"
              :right-column="8"
              is-expert-review
              on="expert-page"
              @set-bookmark="onSetBookmark"
              @set-like="onSetLike"
            />
            <template v-if="reviews.length < options.total">
              <GLoaderSpin v-if="loading.moreReviews" />
              <button v-else class="btn btn-loadmore" @click="onLoadMore">Load more reviews</button>
            </template>
          </template>
        </section>
      </article>
    </div>
    <!-- Modal -->
    <ModalReport />
  </main>
</template>

<script>
const Config = require('~/config/default.env').default;
export default {
  name: 'ExpertPage',
  components: {
    CardReviewDetail: () => import('@/components/dashboard/snippet/card-review-detail'),
    CardReviewDetailV2: () => import('@/components/dashboard/snippet/card-review-detail-v2'),
    // Pagination: () => import('@/components/global/pagination/pagination'),
    ModalReport: () => import('@/components/global/modal/modal-report'),
  },
  data() {
    return {
      banners: [],
      experts: [],
      reviews: [],
      options: {
        limit: 3,
        skip: 0,
        total: 0,
      },
      activePagination: 1,
      loading: {
        banners: true,
        experts: true,
        reviews: true,
        moreReviews: false,
      },
    };
  },
  computed: {
    isDesktop() {
      return this.$store.state.screen.isDesktop;
    },
  },
  created() {
    this.$store.commit('setPageInfo', {
      title: 'Expert Review',
    });
    this.fetchExpertBanners();
    this.fetchExpertUsers();
    this.fetchRecentReviews();
  },
  methods: {
    onSetLike(review) {
      const key = this.reviews.findIndex((res) => res._id === review.reviewId);
      if (key > -1) {
        this.$set(this.reviews[key], 'has_liked', review.value);
      }
    },
    onSetBookmark(review) {
      const key = this.reviews.findIndex((res) => res._id === review.reviewId);
      if (key > -1) {
        this.$set(this.reviews[key], 'has_bookmarked', review.value);
      }
    },
    async fetchExpertBanners() {
      return new Promise((resolve, reject) => {
        try {
          resolve(
            axios.get(Config.MS_SOCO_PUBLIC_API_URL + '/banners', {
              params: {
                filter: {
                  location: 'expert-review-page',
                  screen_type: this.isDesktop ? 'desktop-web' : 'mobile-web',
                },
              },
            })
          );
        } catch (error) {
          reject(error);
        }
      }).then(({ data }) => {
        this.banners = data.data;
        this.loading.banners = false;
      });
    },
    async fetchExpertUsers() {
      return new Promise((resolve, reject) => {
        try {
          resolve(
            axios.get(Config.MS_SOCO_PUBLIC_API_URL + '/expert-users', {
              params: {
                filter: {
                  is_featured_expert_user: true,
                },
                limit: 6,
              },
            })
          );
        } catch (error) {
          reject(error);
        }
      }).then(({ data }) => {
        this.experts = data.data;
        this.loading.experts = false;
      });
    },
    async fetchRecentReviews() {
      if (!this.isDesktop) {
        this.options.limit = 5;
      }
      return Promise.all([this.fetchReviews(), this.fetchReviewsCount()]);
    },
    async fetchReviews() {
      return new Promise((resolve, reject) => {
        try {
          resolve(
            axios.get(Config.MS_SOCO_PUBLIC_API_URL + '/reviews', {
              params: {
                filter: {
                  object_type: 'add-review',
                  'user.is_expert_reviewer': true,
                },
                skip: this.options.skip,
                limit: this.options.limit,
              },
            })
          );
        } catch (error) {
          reject(error);
        }
      }).then(({ data }) => {
        this.reviews = this.isDesktop ? this.reviews.concat(data.data) : [...this.reviews, ...data.data];
        this.loading.reviews = false;
      });
    },
    async fetchReviewsCount() {
      return new Promise((resolve, reject) => {
        try {
          resolve(
            axios.get(Config.MS_SOCO_PUBLIC_API_URL + '/reviews/count', {
              params: {
                filter: {
                  object_type: 'add-review',
                  'user.is_expert_reviewer': true,
                },
              },
            })
          );
        } catch (error) {
          reject(error);
        }
      }).then(({ data }) => {
        this.options.total = data.data;
      });
    },
    mainImage(src) {
      return this.$options.filters.imageCdn({
        config: this.isDesktop ? 'w=1140' : 'w=328',
        image: src,
      });
    },
    usernameUrl(user_name) {
      return `${Config.SOCO_WEB_URL}/${user_name}`;
    },
    onSkip(pagination) {
      this.options.skip = this.options.limit * (pagination.number - 1);
      if (this.$refs['recentlyReviewed']) {
        this.$refs['recentlyReviewed'].scrollIntoView(true);
      }
      this.loading.reviews = true;
      this.fetchReviews();
      this.activePagination = pagination.number;
    },
    onLoadMore() {
      this.options.skip = this.reviews.length;
      this.loading.moreReviews = true;
      this.fetchReviews().finally(() => (this.loading.moreReviews = false));
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/sass/_mixin-revamp.scss';

@mixin sectionHeader() {
  display: flex;
  align-items: center;
  justify-content: space-between;
  h1 {
    margin: 0;
    font-family: $lato-bold;
    font-size: 16px;
    line-height: 22px;
    color: #231f20;
    flex: none;
    order: 0;
    flex-grow: 0;
  }
  small.see-all {
    font-family: $lato-regular;
    font-size: 14px;
    line-height: 22px;
    color: #dc0034;
    flex: none;
    order: 1;
    flex-grow: 0;
  }
}

@mixin carousel() {
  &::v-deep {
    .VueCarousel-wrapper {
      padding-bottom: 26px;
    }
    .VueCarousel-pagination {
      bottom: 0;
      .VueCarousel-dot-container {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 9px;
        button.VueCarousel-dot {
          padding: 0 !important;
          height: 6px !important;
          width: 6px !important;
          &--active {
            height: 10px !important;
            width: 10px !important;
          }
        }
      }
    }
    .VueCarousel-navigation-prev {
      left: 40px;
    }
    .VueCarousel-navigation-next {
      right: 40px;
    }
  }
}

@mixin theExpertRedBg($height: 80px, $width: 100%) {
  &::after {
    content: '';
    position: absolute;
    height: $height;
    width: $width;
    display: block;
    left: 0;
    bottom: 0;
    right: 0;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0) 2.2%,
      rgba(206, 37, 94, 0.71) 66.89%,
      rgba(115, 0, 28, 0.76) 100%
    );
    border-radius: 0px 0px 4px 4px;
  }
}

@mixin theExpertUsername($padding: 12px, $width: unset, $font-size: 13px, $line-height: 17px) {
  position: absolute;
  bottom: 0;
  z-index: 1;
  padding: $padding;
  display: flex;
  flex-direction: column;
  gap: 4px;
  h5 {
    font-family: $lato-bold;
    font-size: $font-size;
    line-height: $line-height;
    color: #ffffff;
    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 0;
  }
  @if ($width != unset) {
    width: $width;
  }
}
.expert-page-desktop {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 1140px;
  margin: auto;
  padding: 24px 0;
  .expert-page-banner {
    @include carousel();
    .VueCarousel-slide.slides {
      width: auto;
      height: 380px;
      // background-image: var(--background);
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
    }
    .expert-main-banner {
      height: 380px;
      width: 100%;
      object-fit: cover;
      border-radius: 4px;
    }
  }
  .meet-our-experts,
  .recently-reviewed-by-experts {
    background: #ffffff;
    padding: 16px 24px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.18);
    border-radius: 4px;
    header {
      @include sectionHeader();
    }
    section {
      ul {
        display: grid;
        align-content: center;
        align-items: start;
        grid-template-columns: repeat(6, minmax(165px, 1fr));
        grid-gap: 20px;
        li {
          position: relative;
          height: 100%;
          .expert-role-wrapper {
            @include theExpertUsername();
          }
          &.the-experts {
            height: 293px;
            width: 165px;
            cursor: pointer;
            &:has(.expert-role-wrapper) {
              @include theExpertRedBg();
            }
            &.default-image {
              img {
                object-fit: cover;
              }
            }
          }
        }
      }
    }
    @media (max-width: 991px) {
      box-shadow: none;
    }
  }
  .recently-reviewed-by-experts::v-deep {
    .card-review-detail {
      border: none;
      border-bottom: 1px solid #e5e5e5;
      background: #fff9fb;
      margin-bottom: 24px;
      padding-top: 40px;
      height: 370px;
      .time {
        top: 6px;
        font-size: 14px;
        line-height: 22px;
        text-align: right;
        color: #8c8582;
      }
      .available-share {
        .card-content {
          margin: 0;
          .right-content {
            padding-left: 0;
          }
          .review-content {
            word-break: break-all;
          }
        }
        .username {
          display: flex;
          gap: 4px;
          align-items: center;
          margin-bottom: 3px;
          flex-wrap: wrap;
        }
      }
      @media (min-width: 992px) {
        &.expert-review .row {
          display: flex;
          flex-direction: row;
          .expert-review-right-column {
            display: flex;
            flex-direction: column;
            .card-content {
              flex: 1;
            }
            .action-bottom-card-timeline--uniform {
              margin: 0;
            }
          }
        }
      }
    }
  }
}
.expert-page-mobile {
  hr.separator {
    height: 8px;
    background: #f8f8f8;
    margin: 0;
    border: none;
  }
  .expert-page-banner {
    padding: 16px 0;
    ul {
      display: inline-flex;
      gap: 12px;
      overflow: auto;
      width: 100%;
      margin-bottom: 0;
      li {
        &:first-child {
          margin-left: 16px;
        }
        &:last-child {
          margin-right: 16px;
        }
        width: 328px;
        height: 184.5px;
        background-image: var(--background-mobile);
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        flex: 1 0 auto;
      }
      img {
        border-radius: 8px;
      }
    }
  }
  .meet-our-experts {
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    header {
      @include sectionHeader();
    }
    .meet-our-experts-carousel {
      @include carousel();
      &::v-deep .VueCarousel-inner {
        margin-right: -8px;
        .VueCarousel-slide {
          position: relative;
          &:has(.expert-role-wrapper) {
            @include theExpertRedBg(91px, calc(100% - 8px));
          }
        }
        .expert-role-wrapper {
          @include theExpertUsername(8px, calc(100% - 8px), clamp(calc(1vw + 9px), 13px, 16px), calc(1vw + 13px));
          small.expert-role {
            font-size: clamp(1vw, 5.5px, 13px);
            font-family: $lato-bold;
            line-height: 7px;
            letter-spacing: 1.0183486938476562px;
            text-align: left;
            height: clamp(calc(1vw + 7px), 13px, 13px);
          }
        }
      }
    }
  }
  .recently-reviewed-by-experts {
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    header {
      @include sectionHeader();
    }
  }
}
.btn-loadmore {
  width: 100%;
  border: 1px solid #333;
  color: #333;
}
</style>
